import React from 'react';
import './style.css';
import ProgressBar from 'react-progressbar';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

const LeftArrowIcon = props => (
  <svg
    {...props}
    fill="currentColor"
    viewBox="0 0 40 40"
    preserveAspectRatio="xMidYMid meet"
  >
    <path d="m28.3 18.3h-12.6l3.8-3.8c0.7-0.6 0.7-1.7 0-2.3s-1.7-0.7-2.3 0l-7.9 7.8 7.9 7.8c0.3 0.4 0.7 0.5 1.1 0.5s0.9-0.1 1.2-0.5c0.7-0.6 0.7-1.7 0-2.3l-3.8-3.8h12.6c1 0 1.7-0.8 1.7-1.7s-0.8-1.7-1.7-1.7z" />
  </svg>
);

const RightArrowIcon = props => (
  <svg
    {...props}
    fill="currentColor"
    viewBox="0 0 40 40"
    preserveAspectRatio="xMidYMid meet"
  >
    <path d="m22.2 12.2c-0.7 0.6-0.7 1.7 0 2.3l3.8 3.8h-12.7c-0.9 0-1.6 0.8-1.6 1.7s0.7 1.7 1.6 1.7h12.7l-3.8 3.8c-0.7 0.6-0.7 1.7 0 2.3 0.3 0.4 0.7 0.5 1.1 0.5s0.9-0.1 1.2-0.5l7.9-7.8-7.9-7.8c-0.6-0.7-1.7-0.7-2.3 0z" />
  </svg>
);

const Header = props => {
  const { t, i18n } = props;
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="App-header">
      <div className="App-navigation">
        <button
          className="backButton"
          onClick={props.history.goBack}
          disabled={
            props.disabledButtons ||
            props.disabledBackButton ||
            !props.history.canGo(-1)
          }
        >
          <LeftArrowIcon
            height="1.5em"
            width="1.5em"
            style={{ verticalAlign: 'middle', marginTop: -3 }}
          />
        </button>{' '}
        {t('INTERVIEW')}{' '}
        <button
          className="backButton"
          onClick={props.history.goForward}
          disabled={props.disabledButtons || !props.history.canGo(1)}
        >
          <RightArrowIcon
            height="1.5em"
            width="1.5em"
            style={{ verticalAlign: 'middle', marginTop: -3 }}
          />
        </button>
        <div className="float-right">
          <button
            className="btn btn-primary btn-round btn-sm"
            onClick={() => changeLanguage('de')}
          >
            DE
          </button>{' '}
          <button
            className="btn btn-primary btn-round btn-sm"
            onClick={() => changeLanguage('en')}
          >
            EN
          </button>
        </div>
      </div>
      <div className="App-progress">
        <div>
          {t('Progress')}: {props.percentage}%
        </div>
        <ProgressBar
          completed={props.percentage}
          color="#FFFFFF"
          height={5}
          className="progressbar"
        />
      </div>
    </div>
  );
};

export default withRouter(translate('translations')(Header));



// WEBPACK FOOTER //
// ./src/preference/components/Header/index.js